module.exports = __webpack_public_path__ + "img/20200507_141009.903b45da.jpg";